<div id="loginActivation" class="registrationdata-container ya-typography">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="true" [disableNavigateBack]="true"
    (onNavigateBackClick)="navigateBack()">
    <h2 class="ya-header-title" langkey="phRegistrationData_Title"></h2>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <div class="content-message">
      <span>{{settingViewModel.register_welcome_text}}</span>
    </div>
    <ya-dynamicFormFields #dynamicFormFieldsComponent *ngIf="registrationFields && registrationFields.length > 0"
      [customerFieldsConfig]="registrationFields" (formStatusChange)="onFormStatusChange()">
    </ya-dynamicFormFields>
    <!--Location selection-->
    <div class="registrationdata-form">
      <div class="registrationdata-location">
        <ng-container *ngIf="locations && locations.length > 1">
          <h2><span langkey="phRegistrationData_Location_Select"></span></h2>
        </ng-container>
        <div class="ya-button-group-wrapper">
          <div class="ya-button-group-container">
            <ng-container *ngIf="locations && locations.length > 1">
              <div class="ya-button-container">
                <button id="btnlocation" mat-flat-button (click)="openLocationModal()">
                  <ng-container
                    *ngIf="likedLocationIds && likedLocationIds.length > 0; then selectedLocationTemplate else noSelectedLocationTemplate">
                  </ng-container>
                  <ng-template #selectedLocationTemplate>
                    <ng-container *ngIf="likedLocationIds && likedLocationIds.length === 1">
                      <span class="selected-location-number">{{likedLocationIds.length}}</span>
                      <span langkey="phRegistrationData_SelectedLocation_Button"></span>
                    </ng-container>
                    <ng-container *ngIf="likedLocationIds && likedLocationIds.length > 1">
                      <span class="selected-location-number">{{likedLocationIds.length}}</span>
                      <span langkey="phRegistrationData_MultipleSelectedLocation_Button"></span>
                    </ng-container>
                  </ng-template>
                  <ng-template #noSelectedLocationTemplate>
                    <span langkey="phRegistrationData_Location_Button"></span>
                  </ng-template>
                </button>
              </div>
            </ng-container>
            <div class="ya-button-container">
              <ng-container
                *ngIf="(registrationForm &&registrationForm.valid && likedLocationIds && likedLocationIds.length > 0); then activeButton else deactiveButton">
              </ng-container>
              <ng-template #activeButton>
                <button mat-flat-button (click)="setUserInfo()">
                  <span langkey="phRegistrationData_Register_Button"></span>
                </button>
              </ng-template>
              <ng-template #deactiveButton>
                <span (click)="showValidationMessage(registrationForm)">
                  <button mat-flat-button disabled>
                    <span langkey="phRegistrationData_Register_Button"></span>
                  </button>
                </span>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="ya-failed-validation-message ya-caption">
          <ya-errorvalidation [controlValidation]="isSubmitted && likedLocationIds && likedLocationIds.length < 1"
            errorMessage="phRegistrationData_Location_Validation_Error">
          </ya-errorvalidation>
        </div>
      </div>
    </div>
  </div>